import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [subscribeMsg, setSubscribeMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt');
    if (honeypot && typeof honeypot === 'string' && honeypot.trim() !== '') {
      setSubscribeStatus('success');
      setEmail('');
      return;
    }
    try {
      const response = await fetch('https://readdy.ai/api/form/d9pbtn2qs38sj6jc7lgg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const text = await response.text();
      if (response.ok) {
        let parsed = null;
        try { parsed = JSON.parse(text); } catch { /* ignore */ }
        if (parsed && parsed.code === 'OK') {
          setSubscribeStatus('success');
          setSubscribeMsg('订阅成功！感谢您的关注。');
          setEmail('');
        } else {
          setSubscribeStatus('error');
          setSubscribeMsg('订阅失败，请稍后再试。');
        }
      } else {
        setSubscribeStatus('error');
        setSubscribeMsg('订阅失败，请稍后再试。');
      }
    } catch {
      setSubscribeStatus('error');
      setSubscribeMsg('网络错误，请稍后再试。');
    }
  };

  return (
    <footer className="bg-background-900" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block group" aria-label="樱花动漫网">
              <span className="text-2xl font-heading font-bold text-primary-500 group-hover:text-primary-400 transition-colors">
                樱花动漫
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              专注韩漫下拉式在线阅读，提供海量高清韩漫资源。流畅的阅读体验，丰富的漫画分类，每天为你带来最新最热的韩漫作品。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-primary-400 hover:bg-background-700 transition-all cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">全部漫画</Link></li>
              <li><Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">恋爱漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">动作漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">奇幻漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/thriller" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">悬疑漫画</Link></li>
              <li><Link to="/category/drama" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">剧情漫画</Link></li>
              <li><Link to="/category/comedy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">搞笑漫画</Link></li>
              <li><Link to="/category/slice-of-life" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">日常漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">订阅更新</h4>
            <p className="text-sm text-foreground-400 mb-3">获取最新韩漫更新通知</p>
            <form onSubmit={handleSubscribe} data-readdy-form="true" className="flex flex-col gap-2">
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱地址"
                  required
                  className="flex-1 px-4 py-2.5 text-sm bg-background-800 border border-background-700 rounded-lg text-foreground-200 placeholder-foreground-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-400 transition-all"
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-all whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </div>
              {subscribeStatus !== 'idle' && (
                <p className={`text-xs mt-1 ${subscribeStatus === 'success' ? 'text-green-400' : 'text-red-400'}`}>
                  {subscribeMsg}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 樱花动漫网. 本站所有资源均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">使用条款</a>
            <a href="#" className="hover:text-foreground-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}